/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateUpdateRevenueAndExpenseDto } from '../models';
// @ts-ignore
import type { RevenueAndExpenseDto } from '../models';
/**
 * RevenueAndExpensesApi - axios parameter creator
 * @export
 */
export const RevenueAndExpensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<CreateUpdateRevenueAndExpenseDto>} createUpdateRevenueAndExpenseDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerCreateUpdateRevenueAndExpenses: async (createUpdateRevenueAndExpenseDto: Array<CreateUpdateRevenueAndExpenseDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpdateRevenueAndExpenseDto' is not null or undefined
            assertParamExists('revenueAndExpensesControllerCreateUpdateRevenueAndExpenses', 'createUpdateRevenueAndExpenseDto', createUpdateRevenueAndExpenseDto)
            const localVarPath = `/revenue-and-expenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdateRevenueAndExpenseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} revenueAndExpenseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerDeleteRevenueAndExpense: async (revenueAndExpenseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revenueAndExpenseId' is not null or undefined
            assertParamExists('revenueAndExpensesControllerDeleteRevenueAndExpense', 'revenueAndExpenseId', revenueAndExpenseId)
            const localVarPath = `/revenue-and-expenses/{revenueAndExpenseId}/delete`
                .replace(`{${"revenueAndExpenseId"}}`, encodeURIComponent(String(revenueAndExpenseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerGetRevenueAndExpenses: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('revenueAndExpensesControllerGetRevenueAndExpenses', 'companyId', companyId)
            const localVarPath = `/revenue-and-expenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RevenueAndExpensesApi - functional programming interface
 * @export
 */
export const RevenueAndExpensesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RevenueAndExpensesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<CreateUpdateRevenueAndExpenseDto>} createUpdateRevenueAndExpenseDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto: Array<CreateUpdateRevenueAndExpenseDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevenueAndExpensesApi.revenueAndExpensesControllerCreateUpdateRevenueAndExpenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} revenueAndExpenseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevenueAndExpensesApi.revenueAndExpensesControllerDeleteRevenueAndExpense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revenueAndExpensesControllerGetRevenueAndExpenses(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RevenueAndExpenseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revenueAndExpensesControllerGetRevenueAndExpenses(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevenueAndExpensesApi.revenueAndExpensesControllerGetRevenueAndExpenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RevenueAndExpensesApi - factory interface
 * @export
 */
export const RevenueAndExpensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RevenueAndExpensesApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<CreateUpdateRevenueAndExpenseDto>} createUpdateRevenueAndExpenseDto Array of nace sections to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto: Array<CreateUpdateRevenueAndExpenseDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} revenueAndExpenseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenueAndExpensesControllerGetRevenueAndExpenses(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RevenueAndExpenseDto>> {
            return localVarFp.revenueAndExpensesControllerGetRevenueAndExpenses(companyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RevenueAndExpensesApi - object-oriented interface
 * @export
 * @class RevenueAndExpensesApi
 * @extends {BaseAPI}
 */
export class RevenueAndExpensesApi extends BaseAPI {
    /**
     * 
     * @param {Array<CreateUpdateRevenueAndExpenseDto>} createUpdateRevenueAndExpenseDto Array of nace sections to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevenueAndExpensesApi
     */
    public revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto: Array<CreateUpdateRevenueAndExpenseDto>, options?: RawAxiosRequestConfig) {
        return RevenueAndExpensesApiFp(this.configuration).revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(createUpdateRevenueAndExpenseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} revenueAndExpenseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevenueAndExpensesApi
     */
    public revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId: string, options?: RawAxiosRequestConfig) {
        return RevenueAndExpensesApiFp(this.configuration).revenueAndExpensesControllerDeleteRevenueAndExpense(revenueAndExpenseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevenueAndExpensesApi
     */
    public revenueAndExpensesControllerGetRevenueAndExpenses(companyId: string, options?: RawAxiosRequestConfig) {
        return RevenueAndExpensesApiFp(this.configuration).revenueAndExpensesControllerGetRevenueAndExpenses(companyId, options).then((request) => request(this.axios, this.basePath));
    }
}

